<template>
    <div>
        <div class="about page">
            <MainMenu />
            <div class="wrapper-about">
                <div @mouseenter="cursorEnter" @mouseleave="cursorOut">
                    <a @click="$router.go(-1)" class="close"> <span> x </span> </a>
                </div>
                <h1 class="title-about">Impressum</h1>
                <div class="text"> 
                    <h2>Angaben gem&auml;&szlig; &sect; 5 TMG</h2>
                    <p>Lisa Miller<br />
                    Lisa Miller Design<br />
                    Moosbruggerstra&szlig;e 3<br />
                    88250 Weingarten</p>

                    <h2>Kontakt</h2>
                    <p>Telefon: 01635138890<br />
                    E-Mail: lisa@millerlisa.com</p>

                    <h2>Umsatzsteuer-ID</h2>
                    <p>Umsatzsteuer-Identifikationsnummer gem&auml;&szlig; &sect; 27 a Umsatzsteuergesetz:<br />
                    DE 340958136</p>

                    <h2>Redaktionell Verantwortlicher</h2>
                    <p>Lisa Miller</p>

                    <h2>Verbraucher&shy;streit&shy;beilegung/Universal&shy;schlichtungs&shy;stelle</h2>
                    <p>Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.</p>

                    <h3>Haftung f&uuml;r Inhalte</h3> <p>Als Diensteanbieter sind wir gem&auml;&szlig; &sect; 7 Abs.1 TMG f&uuml;r eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach &sect;&sect; 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, &uuml;bermittelte oder gespeicherte fremde Informationen zu &uuml;berwachen oder nach Umst&auml;nden zu forschen, die auf eine rechtswidrige T&auml;tigkeit hinweisen.</p> <p>Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unber&uuml;hrt. Eine diesbez&uuml;gliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung m&ouml;glich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.</p> <h3>Haftung f&uuml;r Links</h3> <p>Unser Angebot enth&auml;lt Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb k&ouml;nnen wir f&uuml;r diese fremden Inhalte auch keine Gew&auml;hr &uuml;bernehmen. F&uuml;r die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf m&ouml;gliche Rechtsverst&ouml;&szlig;e &uuml;berpr&uuml;ft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar.</p> <p>Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.</p> <h3>Urheberrecht</h3> <p>Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielf&auml;ltigung, Bearbeitung, Verbreitung und jede Art der Verwertung au&szlig;erhalb der Grenzen des Urheberrechtes bed&uuml;rfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur f&uuml;r den privaten, nicht kommerziellen Gebrauch gestattet.</p> <p>Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.</p>
                </div>
            </div>
        </div>
        <Footer />
    </div>
</template>

<script>
import Footer from '@/components/Footer.vue'
import MainMenu from '@/components/Menu.vue'

export default {
    name: 'Impressum',
    components: {
        MainMenu,
        Footer
    },
    methods: {
        toHome() {
            return "/" + this.$store.state.homeState;
        },
        cursorEnter() {
            this.$store.commit("setMouseOverLink", true);
        },
        cursorOut(){
            this.$store.commit("setMouseOverLink", false);
        }
    }
}
</script>

<style lang="scss" scoped>
$pink: #CA085E;
$lightblue: #C4D1DB;
$midblue: #7AA3C8;
$skyblue: #4476AE;
$darkblue: #031940;
$blackblue: #010819;
$grey: #131313;

.wrapper-about {
    margin-top: 10vh;
    margin-bottom: 5rem;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow-x: hidden;
}
.title-about {
    font-size: 3rem;
    margin-bottom: 5rem;
}

.text {
    width: 70%;
    margin: 0 auto;
    text-align: left;
    h2 {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        font-family: 'Roboto', sans-serif;
        font-style: normal;
        font-size: 1.1em;
        font-weight: 900;
        margin: 50px auto 10px auto;
    }
    h3 {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        font-family: 'Roboto', sans-serif;
        font-style: normal;
        font-size: 1em;
        font-weight: 500;
        margin: 25px auto 0px auto;
    }
    li {
        margin: 0 auto;
        font-size: 0.9em;
    }
    p {
        margin-top: 5px;
        margin-bottom: 0;
        font-size: 0.9em;
    }
}

.contact {
    margin-top: 20px;
}
.about {
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    .close {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 50px;
        height: 50px;
        color: $lightblue;
        margin: 10px auto;
        text-align: center;
        z-index: 1;
        position: relative;
        outline: none;
        border: none;
        border-radius: 30px;
        background-color: #4475ae3b;
        font-size: 2rem;
        font-weight: 400;
        text-shadow: 0 0 0 transparent;
        span {
            position: relative;
            top: -2px;
            left: 0px;
            font-size: 1.7rem;
            font-weight: 300;
        }
    }
    .close::before {
        content: '';
        z-index: -1;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        opacity: 0.5;
        border: 2px solid $skyblue;
        border-radius: 50px;
        transform-origin: center;
        transform: scale(1);
        transition: all 1s ease-out;
    }
    .close:hover::before {
        border: 4px solid $lightblue;
        transition: all 1s ease-out;
        transform-origin: center;
        transform: scale(1.2);
        opacity: 0;
    }
}

@media screen and (max-width: 700px) {
    .wrapper-about {
        margin-top: 10vh;
        .text {
            width: 100%;
        }
    }
    .title-about {
        margin-top: 1rem;
        font-size: 1.5rem;
        margin-bottom: 0rem;
    }
    #about-impressum {
        margin-top: 50px;
        width: 100%;
        p {
            font-weight: 500;
        }
    }
    .about {
        margin: 20px;
        p {
            width: 100%;
            margin: auto;
        }
        .close {
            span {
                top: -3px;
                left: 1px;
            }
        }
    }
}
</style>
